import React from "react";

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

/** Last synchronization; a failure shows the error on hover. */
const SyncStatus = ({ item }: { item: IActiveDirectory }) => {
  const { t } = useTranslation(["client"]);

  if (item.failedAttempts && item.lastSyncError) {
    return (
      <span className="text-danger" title={item.lastSyncError}>
        {t("client:client.integrations.activeDirectory.sync.failing", {
          count: item.failedAttempts,
          since: item.lastSyncErrorAt
            ? dayjs(item.lastSyncErrorAt).format("L LT")
            : "—",
        })}
      </span>
    );
  }

  if (item.lastSyncAt) {
    return <>{dayjs(item.lastSyncAt).format("L LT")}</>;
  }

  return (
    <span className="text-muted">
      {t("client:client.integrations.activeDirectory.sync.never")}
    </span>
  );
};

export default SyncStatus;
